export class ByDefaultAdderss {
    constructor(id) {
        this.id = id;
    }

}
